const fonts = {
  heading: "Playfair Display, Helvetica, sans-serif",
  body: "Archivo, Helvetica, sans-serif",
  mono: "Menlo, Monaco, Consolas, 'Courier New', monospace",
};
export default fonts;
